module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-6.68419973.jpg";